import React, { ReactNode } from 'react'
import Header from './Header'
import Footer from './Footer'

interface IProps {
    children: ReactNode
}

const Page: React.FC<IProps> = ({ children, ...props }) => {
    return(
        <>
            <div className="webiste-main-wrapper">
                <Header />

                <main className="website-main-content">
                    {children}
                </main>

                
            </div>
            <Footer />
        </>
    )
}

export default Page